/** Created by azhou on 2019/3/26.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{item.order_no}}</li>
    <li class="w-50 list-item-col">{{item.tid | formatVar('EXPTYPES')}}</li>
    <li class="w-50 list-item-col" :class="[item.isadd ? 'text-success' : 'text-danger']">
      {{item.isadd ? '+' : '-'}}{{item.exp || item.score}}
    </li>
    <li class="w-50 list-item-col">{{item.adtime | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col">{{item.remark || '无'}}</li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreditDetail',
    props:{
      item:{}
    },
    computed: {
      ...mapGetters(['storeInfo'])
    }
  }
</script>
